export default __webpack_public_path__ + "static/media/preloader2.75845621.gif";